// const API_URL = 'http://127.0.0.1:8080/';
// const API_URL = 'https://4cc3ef3af56a.ngrok.io/';
const API_URL = '/api';

export const getCurrentCountry = async () => {
    try {
        const response = await fetch('https://ipapi.co/json', { mode: 'cors' });
        const json = await response.json();
        return json.country_code;
    } catch (err) {
        console.error('FAILED LOAD CURRENT COUNTRY', err);
    }
    return 'ie';
};

export const getCountries = async () => {
    try {
        const response = await fetch(`${API_URL}/countries`);
        const json = await response.json();
        return json;
    } catch (err) {
        console.error('FAILED LOAD COUNTRY', err);
    }
    return null;
};

export const calculate = async (workers) => {
    const data = workers.map(worker => {
        return {
            iso_code: worker.iso_code,
            job_code: worker.job_code,
            hours: worker.hours
        };
    });
    try {
        // POST
        const response = await fetch(`${API_URL}/calculate`, {
            method: 'POST',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
                // 'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    } catch (err) {
        console.error('FAILED', err);
    }
    return null;
};

export const getCountryByIso = async (iso_code) => {
    try {
        const response = await fetch(`${API_URL}/country/${iso_code.toLowerCase()}`);
        const json = await response.json();
        return json;
    } catch (err) {
        console.error(`FAILED LOAD COUNTRY '${iso_code}'`, err);
    }
    return null;
};
